var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigLogoNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74.166,
    height: 98.135,
    viewBox: "0 0 74.166 98.135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_16114",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 16114",
    transform: "translate(-1.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M2.26,46.076l36.81,13.8,36.81-13.8L39.07,32.28Z",
    transform: "translate(-0.559 -4.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M39.07,0,2.26,13.8l36.81,13.8L75.88,13.8Z",
    transform: "translate(-0.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_16113",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 16113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_16112",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 16112",
    transform: "translate(1.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1331",
    "data-name": "Group 1331",
    transform: "translate(25.703 7.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M54.01,40.465v2.281a22.214,22.214,0,0,1-10.732,2.511c-3.592,0-7.745-.647-10.817-2.511V40.465a32.1,32.1,0,0,0,4.009-3.609c.647-4.264,1.277-8.528,1.855-12.8.23-1.685.485-5.081.485-5.081s-2.468-2.8-2.468-2.885C36.315,13.834,36.324,9,36.324,9H39.03v2.928h2.153V9h4.187v2.919h2.1L47.49,9h2.885v7.4L47.7,18.949s1.6,12.715,2.332,18.094a43.071,43.071,0,0,0,3.983,3.438",
    transform: "translate(-32.46 -9)",
    fill: "#232323"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_291907",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 291907",
    d: "M6.36-6.84V0H2.22V-20.4h7.92q7.2,0,7.2,6.72a6.453,6.453,0,0,1-3,5.88L17.25,0H12.72L10.35-6.84Zm3.84-3.54a2.636,2.636,0,0,0,2.19-.9,3.681,3.681,0,0,0,.72-2.37,3.417,3.417,0,0,0-.765-2.34,2.78,2.78,0,0,0-2.2-.87H6.36v6.48ZM25.065-4.815A3.464,3.464,0,0,0,28.38-3.24a3.464,3.464,0,0,0,3.315-1.575,11.473,11.473,0,0,0,.885-5.28,12.013,12.013,0,0,0-.9-5.385,3.4,3.4,0,0,0-3.3-1.68,3.4,3.4,0,0,0-3.3,1.68,12.013,12.013,0,0,0-.9,5.385A11.473,11.473,0,0,0,25.065-4.815Zm9.87,2.64Q33.03.36,28.38.36T21.825-2.175Q19.92-4.71,19.92-10.11t1.905-8.025q1.9-2.625,6.555-2.625t6.555,2.625Q36.84-15.51,36.84-10.11T34.935-2.175Zm9.69-2.64A3.464,3.464,0,0,0,47.94-3.24a3.464,3.464,0,0,0,3.315-1.575,11.473,11.473,0,0,0,.885-5.28,12.013,12.013,0,0,0-.9-5.385,3.4,3.4,0,0,0-3.3-1.68,3.4,3.4,0,0,0-3.3,1.68,12.013,12.013,0,0,0-.9,5.385A11.473,11.473,0,0,0,44.625-4.815Zm9.87,2.64Q52.59.36,47.94.36T41.385-2.175Q39.48-4.71,39.48-10.11t1.9-8.025Q43.29-20.76,47.94-20.76T54.5-18.135Q56.4-15.51,56.4-10.11T54.5-2.175ZM64.08,0H59.94V-20.4h4.14v8.97l2.76-.3L70.2-20.4h4.71L70.47-10.17,75.03,0H70.26L66.84-8.13l-2.76.3Z",
    transform: "translate(0 79.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_17036",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 17036",
    transform: "translate(-1.178 81)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_574",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 574",
    x1: 6.579,
    transform: "translate(67.943 11.5)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_291908",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 291908",
    d: "M8.19,0V-5.01H1.92V0H1.38V-10.5h.54v4.98H8.19V-10.5h.54V0Zm5.6-1.628a2.18,2.18,0,0,0,1.057.953,4.449,4.449,0,0,0,1.763.3,4.711,4.711,0,0,0,1.755-.278,2.087,2.087,0,0,0,1.05-.915,4.3,4.3,0,0,0,.5-1.478,14.074,14.074,0,0,0,.135-2.16,7.38,7.38,0,0,0-.727-3.72,2.921,2.921,0,0,0-2.723-1.2A2.912,2.912,0,0,0,13.8-8.82a4.781,4.781,0,0,0-.5,1.507A13.083,13.083,0,0,0,13.153-5.2a13.347,13.347,0,0,0,.135,2.092A4.449,4.449,0,0,0,13.791-1.628Zm-.412.4a4.7,4.7,0,0,1-.623-1.658A13.1,13.1,0,0,1,12.583-5.2a7.628,7.628,0,0,1,.87-4.1,3.474,3.474,0,0,1,3.15-1.335,3.483,3.483,0,0,1,3.15,1.328,7.729,7.729,0,0,1,.87,4.148A7.4,7.4,0,0,1,19.776-1.1Q18.928.135,16.573.135T13.378-1.23ZM22.4-9.99v-.51h7.5v.51H26.44V0H25.9V-9.99ZM32.978,0V-10.5h6.135v.51H33.518v4.365h4.695v.51H33.518V-.51h5.595V0ZM48.412,0H42.757V-10.5h.54V-.51h5.115Z",
    transform: "translate(13.531 17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_573",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 573",
    x1: 6.579,
    transform: "translate(2.332 11.5)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigLogoNew);
export default __webpack_public_path__ + "static/media/bigLogoNew.c24e405db237174c3b533cce07e23049.svg";
export { ForwardRef as ReactComponent };